module.exports = __webpack_public_path__ + "static/media/sonicbathtub2.e6b55f61.jpg";